import { inject, Injectable } from '@angular/core';
import { whoamiFrag } from './types/init.types';
import { ThemeService } from './theme.service';
import { defaultAppConfig } from '../../content/service/types/user.types';
import { UserGqlService } from '../../../services/user.gql-service';
import { AppConfig, LayoutService } from './layout.service';

@Injectable({ providedIn: 'root' })
export class InitializerService {
    private userService = inject(UserGqlService);
    private layoutService = inject(LayoutService);
    private themeService = inject(ThemeService);

    async load(): Promise<void> {
        const user = await this.userService.whoami(whoamiFrag);
        this.layoutService.config.set(user?.settings as AppConfig || defaultAppConfig);
        this.themeService.setTheme(user?.settings || defaultAppConfig);
        this.hideLoader();
    }

    hideLoader() {
        const loader = document.getElementById('app-init-loader');
        if (loader) {
            loader.classList.add('init-fade-out');

            setTimeout(() => {
                loader.remove();
            }, 200);
        }
    }
}
